export const enviroment = {
  baseUrl: "http://localhost:3000/",
};